import { useAppContext } from '../providers/AppContextWrapper'
import { Applications } from '../utils/application-type'

export const useIsOfficeApp = () => {
  return useAppContext().appType === Applications.OFFICE
}
